import axios, { AxiosError, HttpStatusCode } from 'axios';
import {
  FightNotFoundError,
  FightServerError,
} from '../../corelogic/domain/errors/fight.error';
import { FIGHT_ERROR_MESSAGES } from '../../corelogic/domain/errors/gateway.errorMessages/fight.error.messages';
import { Fight } from '../../corelogic/domain/models/fight.model';
import { FightGateway } from '../../corelogic/domain/ports/fight.port';
import { getSecureRequestHeaders } from '../../corelogic/domain/utils/securityHeaders.utils';

export class ApiFightGateway implements FightGateway {
  private apiEndpoint: string;

  private handleFightError(error: AxiosError): never {
    if (axios.isAxiosError(error)) {
      switch (error.response?.status) {
        case HttpStatusCode.NotFound:
          throw new FightNotFoundError(FIGHT_ERROR_MESSAGES.NOT_FOUND);
        default:
          throw new FightServerError(FIGHT_ERROR_MESSAGES.SERVER_ERROR);
      }
    }
    throw new FightServerError(FIGHT_ERROR_MESSAGES.SERVER_ERROR);
  }

  constructor(apiEndpoint: string) {
    this.apiEndpoint = apiEndpoint;
  }

  async getFights(): Promise<Fight[]> {
    try {
      const response = await axios.get<{ fights: Fight[] }>(
        `${this.apiEndpoint}/fights`,
        {
          headers: {
            ...getSecureRequestHeaders(),
          },
        },
      );
      return response.data.fights;
    } catch (error) {
      throw this.handleFightError(error as AxiosError);
    }
  }

  async getFightById(id: string): Promise<Fight> {
    try {
      const response = await axios.get<{ fight: Fight }>(
        `${this.apiEndpoint}/fights/${id}`,
        {
          headers: {
            ...getSecureRequestHeaders(),
          },
        },
      );
      return response.data.fight;
    } catch (error) {
      throw this.handleFightError(error as AxiosError);
    }
  }
}
